__webpack_require__.p = "https://dashboard.airthings.com/";